import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';


// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function OrganizationMoreMenu({ handleUser, handleClicks, sx}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);




  return (
    <Box data-testid='organization-more-menu'>
      <IconButton data-testid='org-menu-icon' sx={{...sx}} ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
          
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

        <MenuItem onClick={() => {setIsOpen(false); handleClicks("add_user")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <PersonAddAlt1OutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Add User" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() => {setIsOpen(false); handleClicks("view_users")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <GroupOutlinedIcon  />
          </ListItemIcon>
          <ListItemText primary="View Users" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() => {setIsOpen(false); handleClicks("add_merchants")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <AddBusinessOutlinedIcon  />
          </ListItemIcon>
          <ListItemText primary="Add Merchant" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() => {setIsOpen(false); handleClicks("view_merchants")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <StoreOutlinedIcon  />
          </ListItemIcon>
          <ListItemText primary="View Merchants" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() => {setIsOpen(false); handleClicks("upload_organization_branch")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <AccountBalanceOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Upload Branch List" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        

          {/* <MenuItem onClick={() => handleClicks("edit_driver")} component={RouterLink} to="#" sx={{ color: 'text.secondary' }}> 
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Alert Device " primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>  */}


{/* 
<MenuItem onClick={() => {setIsOpen(false); handleClicks("view_trips")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DeviceHubOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="View Trips" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("export_report")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Export Report" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("report_issue")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Report Issue" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("device_settings")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Device Settings" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}


      </Menu>
    </Box>
  );
}
